import { TableColumn } from '../../models';
import { BadgeCellComponent, BadgeCellProps } from './badge.component';

export class BadgeColumn<I> extends TableColumn<I, BadgeCellProps> {
  readonly component = BadgeCellComponent;
}
